import { render, staticRenderFns } from "./Showcreaten.vue?vue&type=template&id=2aabd9d5&scoped=true&"
import script from "./Showcreaten.vue?vue&type=script&lang=ts&"
export * from "./Showcreaten.vue?vue&type=script&lang=ts&"
import style0 from "./Showcreaten.vue?vue&type=style&index=0&id=2aabd9d5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aabd9d5",
  null
  
)

export default component.exports